"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouteHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));
var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _Typography = require("./Typography");
var _pittaModules = require("@thingsw/pitta-modules");
var _IconButton = require("./IconButton");
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // Mui List 기본 요소
// 아이콘
// 커스텀 컴포넌트
////////////////////////////////////////////////////////////////////////////////////////
// 인터페이스
////////////////////////////////////////////////////////////////////////////////////////
// CSS 스타일
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles.createStyles)({
    root: {
      width: "100%",
      maxWidth: 500,
      padding: "0 0 0 0",
      backgroundColor: theme.palette.background.paper
      //backgroundColor: "rgba(0,0,0,0.1)",
    },

    list: {
      width: "100%",
      height: "100%",
      "&:hover": {
        backgroundColor: "rgba(0,0,0,0)"
      }
    },
    appList: {
      display: "flex",
      alignItems: "center",
      width: "92%",
      height: "100%",
      "&:hover": {
        backgroundColor: "rgba(0,0,0,0)"
      }
    },
    heading: {
      display: "flex"
    },
    content: {
      display: "flex",
      marginTop: "5px"
    },
    appContent: _objectSpread({
      display: "flex"
    }, theme.direction === "rtl" ? {
      marginRight: 16
    } : {
      marginLeft: 16
    }),
    item: {
      padding: theme.spacing(1, 2),
      backgroundColor: "".concat(_pittaModules.LightColors.primary["6"], "5A"),
      "& > *": {
        marginBottom: theme.spacing(0.5)
      },
      "& > :last-child": {
        marginBottom: 0
      }
    },
    circle: {
      borderRadius: "50%",
      border: "1px solid ".concat(_pittaModules.LightColors.primary["4"]),
      display: "flex"
    },
    activeCircle: {
      border: "1px solid ".concat(_pittaModules.LightColors.primary["7"])
    },
    appIcon: {
      color: _pittaModules.LightColors.primary["2"],
      fontSize: 22
    },
    activeStyle: {
      color: _pittaModules.LightColors.primary["7"]
    }
  });
});
////////////////////////////////////////////////////////////////////////////////////////
// 실제 컴포넌트
var RouteHeader = function RouteHeader(props) {
  var classes = useStyles();
  var heading = props.heading,
    content = props.content,
    open = props.open,
    onClick = props.onClick,
    app = props.app;
  var theme = (0, _styles.useTheme)();
  return /*#__PURE__*/_react.default.createElement(_ListItem.default, {
    dir: theme.direction,
    className: classes.list,
    style: {
      paddingTop: app ? 13 : 8
    },
    button: true,
    onClick: onClick,
    disableRipple: true
  }, app ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.appList
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.heading
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Large",
    variant: "H6",
    htmlColor: open ? _pittaModules.LightColors.primary["7"] : _pittaModules.LightColors.primary["1"]
  }, heading)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.appContent
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Small",
    htmlColor: open ? _pittaModules.LightColors.primary["7"] : _pittaModules.LightColors.primary["1"]
  }, content.replace("~", "|").split("|").map(function (str, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index
    }, index === 1 ? "~ ".concat(str) : str);
  })))) : /*#__PURE__*/_react.default.createElement("div", {
    className: classes.list
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.heading
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Body"
  }, heading)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Caption"
  }, content))), open ? /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, null, app ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.circle, classes.activeCircle)
  }, /*#__PURE__*/_react.default.createElement(_ExpandLess.default, {
    className: (0, _clsx.default)(classes.appIcon, classes.activeStyle)
  })) : /*#__PURE__*/_react.default.createElement(_ExpandLess.default, null)) : /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, null, app ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.circle
  }, /*#__PURE__*/_react.default.createElement(_ExpandMore.default, {
    className: classes.appIcon
  })) : /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null)));
};
exports.RouteHeader = RouteHeader;